import React from "react";

const BankDetailsForm = ({ bankDetails, setBankDetails }) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    setBankDetails((prevDetails) => ({
      ...prevDetails,
      [name]: value,
    }));
  };

  return (
    <div className="mb-6">
      <div className="text-xl font-semibold text-gray-800 mb-1">
        Bank Details for Refund
      </div>
      <p className="text-sm text-gray-600 mb-6">
        Please provide accurate bank account details to ensure your refund is processed seamlessly. Double-check your account number and IFSC code to avoid any delays.
      </p>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1" htmlFor="accountHolderName">
            Account Holder's Name
          </label>
          <input
            type="text"
            id="accountHolderName"
            name="accountHolderName"
            value={bankDetails.accountHolderName}
            onChange={handleChange}
            placeholder="Enter account holder's full name"
            className="px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent w-full"
            required
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1" htmlFor="accountNumber">
            Bank Account Number
          </label>
          <input
            type="text"
            id="accountNumber"
            name="accountNumber"
            value={bankDetails.accountNumber}
            onChange={handleChange}
            placeholder="Enter your bank account number"
            className="px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent w-full"
            required
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1" htmlFor="ifscCode">
            IFSC Code
          </label>
          <input
            type="text"
            id="ifscCode"
            name="ifscCode"
            value={bankDetails.ifscCode}
            onChange={handleChange}
            placeholder="Enter IFSC code (e.g., SBIN0001234)"
            className="px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent w-full"
            required
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1" htmlFor="bankName">
            Bank Name
          </label>
          <input
            type="text"
            id="bankName"
            name="bankName"
            value={bankDetails.bankName}
            onChange={handleChange}
            placeholder="Enter bank name (e.g., State Bank of India)"
            className="px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent w-full"
            required
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1" htmlFor="branchName">
            Branch Name
          </label>
          <input
            type="text"
            id="branchName"
            name="branchName"
            value={bankDetails.branchName}
            onChange={handleChange}
            placeholder="Enter branch name (e.g., Connaught Place)"
            className="px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent w-full"
            required
          />
        </div>
      </div>
    </div>
  );
};

export default BankDetailsForm;
